module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main"
  }, [_c('div', {
    staticClass: "formpage"
  }, [_c('div', {
    staticClass: "right_col",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "main_main_contents"
  }, [_vm._m(0), _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h3",
    attrs: {
      "id": "control-label",
      "for": "title"
    }
  }, [_vm._v(" フォームのタイトル")]), _c('label', {
    staticClass: "notice"
  }, [_vm._v("タイトル入力後、テキストボックス外をクリックしてください。")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.title.$dirty && _vm.$v.title.$invalid
    },
    attrs: {
      "id": "form_title",
      "type": "text",
      "placeholder": "このフォームのタイトルを入力してください"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "blur": _vm.changeTitle,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }, _vm.$v.title.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.title.$dirty && _vm.$v.title.$invalid),
      expression: "$v.title.$dirty && $v.title.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.title.required),
      expression: "!$v.title.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.title.maxLength),
      expression: "!$v.title.maxLength"
    }]
  }, [_vm._v("100文字以下で入力してください")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.id != "new"),
      expression: "$route.params.id != `new`"
    }],
    attrs: {
      "role": "tabpanel",
      "data-example-id": "togglable-tabs"
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "mail_tab"
    }
  }, [_c("mail", {
    tag: "div",
    attrs: {
      "id": "mailsetting",
      "data": _vm.form,
      "role": "tabpanel",
      "aria-labelledby": "recmail-tab"
    },
    on: {
      "update:data": function($event) {
        _vm.form = $event
      }
    }
  })]), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "item_tab"
    }
  }, [_c("item", {
    tag: "div",
    attrs: {
      "id": "itemsetting",
      "data": _vm.form,
      "role": "tabpanel",
      "aria-labelledby": "item-tab"
    },
    on: {
      "update:data": function($event) {
        _vm.form = $event
      }
    }
  })])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "title_left"
  }, [_c('h2', [_vm._v("フォーム編集")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs bar_tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "id": "recmail-tab",
      "href": "#mail_tab",
      "role": "tab",
      "data-toggle": "tab",
      "aria-controls": "recmail",
      "aria-expanded": "false"
    }
  }, [_vm._v("送受信メール設定")])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "id": "item-tab",
      "href": "#item_tab",
      "role": "tab",
      "data-toggle": "tab",
      "aria-controls": "item",
      "aria-expanded": "true"
    }
  }, [_vm._v("項目設定")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-206bd7cc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Form/Index.vue
// module id = 594
// module chunks = 1